import { React, useContext, useEffect, useRef, useState } from 'react';
import { GlobalContext } from '../state/GlobalContext';
import Config from '../shared/Config';
import RenderMarkups from '../shared/RenderMarkups';
import IncorrectAge from './IncorrectAge';
import NoMenstrualPeriod from './NoMenstrualPeriod';
import ThankYouPage from './ThankYouPage';
import axios from 'axios';


export default function GeneralStep() {
    const { state, setState } = useContext(GlobalContext);
    const questionWrapper = document.querySelector('#menopause-test-root');

    const [inputsState, setInputsState] = useState({
        name: false,
        surname: false,
        email: false,
        acceptance: false,
    });

    const specialAnswersRef = useRef(null);
    const userChoicesRef = useRef(null);
    const userFormDataRef = useRef(null);

    useEffect(() => {
        if(state.shouldScroll) {
            window.scroll(questionWrapper.getBoundingClientRect.left,questionWrapper.getBoundingClientRect.top)
            setState({
                ...state,
                shouldScroll: false,
            })
        }
    }, []);

    function incrementStep(){
        let inputStepId = parseInt(userChoicesRef.current.querySelector("input:checked").getAttribute('data-step'));
        let inputId = parseInt(userChoicesRef.current.querySelector("input:checked").getAttribute('data-answer-id'));

        state.selectedAnswers[inputStepId] = inputId
        if(state.canGoFurther){
            if(state.showSpecialAnswer){
                setState({
                    ...state,
                    isSpecialAnswer: true,
                });
            }else{
                setState({
                    ...state,
                    step: state.step+1,
                    canGoFurther: false,
                });
            }
        }
        if(questionWrapper){
            window.scrollTo(questionWrapper.getBoundingClientRect.left,questionWrapper.getBoundingClientRect.top)
        }
    }
    
    function decrementStep(){
        if(state.showSpecialAnswer){
            setState({
                ...state,
                isSpecialAnswer: false,
                showSpecialAnswer: false,
                canGoFurther: true,
            });
        }else{
            setState({
                ...state,
                step: state.step-1,
                canGoFurther: true,
            });
        }
        if(questionWrapper){
            window.scrollTo(questionWrapper.getBoundingClientRect.left,questionWrapper.getBoundingClientRect.top)
        }
    }
    function decrementLastStep(){
        setState({
            ...state,
            step: state.step,
            lastStep: false,
            canGoFurther: true,
        })
    }
    function checkIfNextStepsAreAvailable(){
        let endTest = specialAnswersRef.current.querySelector("input:checked").getAttribute('data-end-test');
        let specialAnswer = specialAnswersRef.current.querySelector("input:checked").value;
        if(endTest == 'true'){
            setState({
                ...state,
                noMenstrualPeriod: true,
            })
        }else{
            setState({
                ...state,
                step: state.step+1,
                noMenstrualPeriod: false,
                showSpecialAnswer: false,
                isSpecialAnswer: false,
                selectedSpecialAnswer: parseInt(specialAnswer),
            })
        }
    }
    function unlockNextQuestion(){
        let inputChoice = userChoicesRef.current.querySelector('input:checked').getAttribute('data-special-answer')
        if(inputChoice == 'true'){
            setState({
                ...state,
                showSpecialAnswer: true,
                canGoFurther: true,
            });
        }else{
            setState({
                ...state,
                canGoFurther: true,
                showSpecialAnswer: false,
            });
        }
    }
    function unlockNextQuestionAfterSpecial(){
        setState({
            ...state,
            canGoFurther: true,
        });
    }
    function setLastStep(){
        let inputStepId = parseInt(userChoicesRef.current.querySelector("input:checked").getAttribute('data-step'));
        let inputId = parseInt(userChoicesRef.current.querySelector("input:checked").getAttribute('data-answer-id'));

        state.selectedAnswers[inputStepId] = inputId
        setState({
            ...state,
            lastStep: true,
        });
    }
    function canSendForm(){
        let acceptanceMail = userFormDataRef.current.querySelector("#email_acceptance")
        if(acceptanceMail.checked){
            setInputsState({
                ...inputsState,
                acceptance: true,
            })
        }else{
            setInputsState({
                ...inputsState,
                acceptance: false,
            })
        }
    }
    function checkInputValidity(e){
        if(e.target.id == 'user_name'){
            if(e.target.value != ""){
                setInputsState({
                    ...inputsState,
                    name: true,
                })
            }else{
                setInputsState({
                    ...inputsState,
                    name: false,
                })
            }
        }
        if(e.target.id == 'user_surname'){
            if(e.target.value != ""){
                setInputsState({
                    ...inputsState,
                    surname: true,
                })
            }else{
                setInputsState({
                    ...inputsState,
                    surname: false,
                })
            }
        }
        if(e.target.id == 'user_email'){
            if(e.target.value != ""){
                setInputsState({
                    ...inputsState,
                    email: true,
                })
            }else{
                setInputsState({
                    ...inputsState,
                    email: false,
                })
            }
        }
    }
    function sendUserData(){
        let testData = new FormData;

        let emailAcceptance = userFormDataRef.current.querySelector('#email_acceptance').checked ? true : false;
        let mailchimpAcceptance = true;
        // let mailchimpAcceptance = userFormDataRef.current.querySelector('#mailchimp_acceptance').checked ? true : false;

        let testResult = countUserAnswers();
        let userChoices = JSON.stringify(storeUserAnswers());
        
        testData.append("username",userFormDataRef.current.querySelector('#user_name').value);
        testData.append("surname",userFormDataRef.current.querySelector('#user_surname').value);
        testData.append("email",userFormDataRef.current.querySelector('#user_email').value);
        testData.append("send_mail",emailAcceptance);
        testData.append("sign_in_mailchimp",mailchimpAcceptance);
        testData.append("user_age",state.userAge);
        testData.append("answers",userChoices);
        testData.append("diagnose",testResult);

        axios.post('/submit-test',testData);

        setState({
            ...state,
            thankYouPage: true,
            lastStep: false,
        });
    }
    
    function baseResultCalculation(userAnswers){
        let testResult = "";

        if(userAnswers['menopausePoints'] <= 4){
            testResult = "Keine";
       }
       if(userAnswers['menopausePoints'] > 4 && userAnswers['menopausePoints'] <= 19){
            testResult = "Moglich";
       }
       if(userAnswers['menopausePoints'] >= 20){
            testResult = "Wechseljahre";
       }
       return testResult;
    }
    function storeUserAnswers(){
        let userChoices = {};

        state.testData.questions.map((question,questionIndex) => {
            question.answers_repeater.map((answer,answerIndex) => {
                if(state.selectedAnswers[questionIndex] == answerIndex){
                    userChoices[questionIndex] = answer.answer_label;
                }
            })
        })
        return userChoices;
    }
    function countUserAnswers(){
        let userAnswersScore = {'menopausePoints': 0, 'prampPoints': 0, 'perimpPoints': 0};
        let testResult = '';
        
        state.testData.questions.map((question,questionIndex) => {
            question.answers_repeater.map((answer,answerIndex) => {
                if(state.selectedAnswers[questionIndex] == answerIndex){
                    if(answer.menopause_point_value == ""){
                        answer.menopause_point_value = 0;
                    }
                    if(answer.pramp_point_value == ""){
                        answer.pramp_point_value = 0;
                    }
                    if(answer.perimp_point_value == ""){
                        answer.perimp_point_value = 0;
                    }
                    userAnswersScore['menopausePoints'] += parseInt(answer.menopause_point_value);
                    userAnswersScore['prampPoints'] += parseInt(answer.pramp_point_value);
                    userAnswersScore['perimpPoints'] += parseInt(answer.perimp_point_value);
                    
                }
            })
        })
        // Base calculation
        if(state.selectedAnswers[0] === 0){
            testResult = baseResultCalculation(userAnswersScore);
        }
        // PraMP
        if( (state.selectedAnswers[0] == 1 || state.selectedAnswers[0] == 2) && (state.selectedAnswers[1] == 1 || state.selectedAnswers[1] == 2) && state.userAge <= 44 ){
            if(userAnswersScore['prampPoints'] >= 6){
                testResult = 'PraMP';
            }
            if(userAnswersScore['prampPoints'] < 6){
                testResult = baseResultCalculation(userAnswersScore);
            }
        }
        // PeriMP
        if( (state.selectedAnswers[0] == 1 || state.selectedAnswers[0] == 2) && (state.selectedAnswers[1] == 1 || state.selectedAnswers[1] == 2) && state.userAge >= 45 ){
            if(userAnswersScore['perimpPoints'] >= 6){
                testResult = 'PeriMP';
            }
            if(userAnswersScore['perimpPoints'] < 6){
                testResult = baseResultCalculation(userAnswersScore);
            }
        }
        // Special answer
        if( state.selectedSpecialAnswer ==  0 && state.userAge >= 45){
            testResult = "PostMP";
        }
        if( state.selectedSpecialAnswer == 0 && state.userAge <= 44 ){
            testResult = "Vorzeitige";
        }
        if( state.selectedSpecialAnswer == 2 ){
            testResult = "MedizinischInduzierte";
        }

        return testResult;
    }

    if(state.incorrectAge == true){
        return (
            <IncorrectAge/>
        );
    }
    if(state.noMenstrualPeriod == true){
        return (
            <NoMenstrualPeriod/>
        );
    }
    if(state.thankYouPage == true){
        return (
            <ThankYouPage/>
        );
    }
    if(state.incorrectAge != true && state.noMenstrualPeriod != true && state.thankYouPage != true){
        return (
            <div className="row">
                <div className='col'>
                    <div className={`${state.lastStep ? 'question-card-wrapper final-step' : 'question-card-wrapper'}${state.isSpecialAnswer ? '  special-step' : ''}`}>
                        <div className="inside-wrapper">
                            <div className="row-card">
                                {state.isSpecialAnswer == true &&
                                     <>
                                        <div className="col-card-icon">
                                            <div className="progress-indicator-wrapper">
                                                <div className="text-progress">
                                                    {state.lastStep != true ?
                                                        <p><strong><span className="ui-counter-mobile-hide">{state.testData.general_settings.question_label}</span>{' ' + (state.step + 1) + (state.isSpecialAnswer ? 'B' : '')} <span className='ui-counter-mobile-hide'>{state.testData.general_settings.question_one_of}</span><span className='divider-mobile-only'> / </span> {state.testData.questions.length}</strong></p>
                                                    :
                                                        <>
                                                            <p className='hide-on-mobile-only'><strong>{state.testData.finish_step.counter_text}</strong></p>
                                                            <p className='hide-on-desktop'><strong>Kontakdaten</strong></p>
                                                        </>
                                                    }
                                                </div>
                                                <div className="progress-bar">
                                                    <div className="progress"></div>
                                                </div>
                                            </div>
                                            <img src={state.testData.special_question.icon} alt={`Icon ${state.step}B`} />
                                        </div>
                                        <div className="col-card-content">
                                            <h1>{state.testData.special_question.heading}</h1>
                                            <div className="special-answers-wrapper" ref={specialAnswersRef}>
                                                {state.testData.special_question.questions.map((answer,index) => {
                                                    return (
                                                        <div key={`answer_${index}b_step_${state.step}`} className='single-answer-wrapper-special-question'>
                                                            <input value={index} onClick={() => unlockNextQuestionAfterSpecial()} id={`answer_${index}b_step_${state.step}`} data-end-test={answer.should_end_test} type="radio" name={`step_${state.step}`} className="check-input-btn"/>
                                                            <label htmlFor={`answer_${index}b_step_${state.step}`} dangerouslySetInnerHTML={RenderMarkups(answer.special_question_text)}/>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                        <div className="col-card-answers"></div>
                                    </>
                                }
                                {state.isSpecialAnswer == false && state.lastStep == false &&
                                     <>
                                        <div className="col-card-icon">
                                            <div className="progress-indicator-wrapper">
                                                <div className="text-progress">
                                                    {state.lastStep != true ?
                                                        <p><strong><span className="ui-counter-mobile-hide">{state.testData.general_settings.question_label}</span>{' ' + (state.step + 1) + (state.isSpecialAnswer ? 'B' : '')} <span className='ui-counter-mobile-hide'>{state.testData.general_settings.question_one_of}</span><span className='divider-mobile-only'>  </span> {state.testData.questions.length}</strong></p>
                                                    :
                                                        <>
                                                            <p className='hide-on-mobile-only'><strong>{state.testData.finish_step.counter_text}</strong></p>
                                                            <p className='hide-on-desktop'><strong>Kontakdaten</strong></p>
                                                        </>
                                                    }
                                                </div>
                                                <div className="progress-bar">
                                                    <div className="progress" style={{width: (100 * (parseInt(state.step+1) / parseInt(state.testData.questions.length))) + '%' }}></div>
                                                </div>
                                            </div>
                                            <img src={state.testData.questions[state.step].question_icon} alt={`Icon ${state.step}`} />
                                        </div>
                                        <div className="col-card-content">
                                            <h1>{state.testData.questions[state.step].question}</h1>
                                            {state.testData.questions[state.step].info_text &&
                                                <div className="info-text hide-on-mobile-only" dangerouslySetInnerHTML={RenderMarkups(state.testData.questions[state.step].info_text)}/>
                                            }
                                        </div>
                                        <div className="col-card-answers" ref={userChoicesRef}>
                                            {state.testData.questions[state.step].answers_repeater.map((answer,index) => {
                                                return (
                                                    <div key={`answer_${index}_step_${state.step}`} className='single-answer-wrapper'>
                                                        {answer.is_special_answer == true ?
                                                            <>
                                                                <input defaultChecked={state.selectedAnswers[state.step] == index} data-special-answer="true" data-step={state.step} data-answer-id={index} onClick={() => unlockNextQuestion()} id={`answer_${index}_step_${state.step}`} type="radio" name={`step_${state.step}`} className="check-input-btn" value={answer.menopause_point_value} data-pramp-val={answer.pramp_point_value} data-perimp-val={answer.perimp_point_value}/>
                                                                <label htmlFor={`answer_${index}_step_${state.step}`}>
                                                                    {answer.answer_label}
                                                                </label>
                                                            </>
                                                        :   
                                                            <>
                                                                <input defaultChecked={state.selectedAnswers[state.step] == index} data-special-answer="false" data-step={state.step} data-answer-id={index} onClick={() => unlockNextQuestion()} id={`answer_${index}_step_${state.step}`} type="radio" name={`step_${state.step}`} className="check-input-btn" value={answer.menopause_point_value} data-pramp-val={answer.pramp_point_value} data-perimp-val={answer.perimp_point_value}/>
                                                                <label htmlFor={`answer_${index}_step_${state.step}`}>
                                                                    {answer.answer_label}
                                                                </label>
                                                            </>
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        {state.testData.questions[state.step].info_text &&
                                            <div className="info-text hide-on-desktop-only" dangerouslySetInnerHTML={RenderMarkups(state.testData.questions[state.step].info_text)}/>
                                        }
                                    </>
                                }
                                {state.lastStep == true ? 
                                    <div className="row-card">
                                        <div className='flex-display' ref={userFormDataRef}>
                                            <div className="col-100 heading-col" dangerouslySetInnerHTML={RenderMarkups(state.testData.finish_step.heading)}/>
                                            <div className="col-100 desc-col" dangerouslySetInnerHTML={RenderMarkups(state.testData.finish_step.desc)}/>
                                            <div className="col-6-input">
                                                <input onChange={(e) => checkInputValidity(e) } id="user_name" type="text" name="user_name" placeholder={state.testData.finish_step.name_input}/>
                                            </div>
                                            <div className="col-6-input">
                                                <input onChange={(e) => checkInputValidity(e) } id="user_surname" type="text" name="user_surname" placeholder={state.testData.finish_step.surname_input}/>
                                            </div>
                                            <div className="col-12-input">
                                                <input onChange={(e) => checkInputValidity(e) } id="user_email" type="email" name="user_email" placeholder={state.testData.finish_step.email_input}/>
                                            </div>
                                            <div className="col-100 col-check-acceptance">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="51" viewBox="0 0 52 51">
                                                    <g id="Group_12293" data-name="Group 12293" transform="translate(-687 -762)">
                                                        <rect id="Rectangle_8368" data-name="Rectangle 8368" width="52" height="51" rx="25.5" transform="translate(687 762)" fill="#f8f5f9"/>
                                                        <g id="Group_11962" data-name="Group 11962" transform="translate(-485.584 -5765.676)">
                                                        <g id="Ellipse_615" data-name="Ellipse 615" transform="translate(1181.647 6536)" fill="#fff" stroke="#e3dcf1" stroke-width="1">
                                                            <ellipse cx="17.176" cy="17.176" rx="17.176" ry="17.176" stroke="none"/>
                                                            <ellipse cx="17.176" cy="17.176" rx="16.676" ry="16.676" fill="none"/>
                                                        </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <input onClick={() => canSendForm()} id="email_acceptance" type="checkbox" value="true"/>
                                                <label className="acceptance-area" htmlFor="email_acceptance" dangerouslySetInnerHTML={RenderMarkups(state.testData.finish_step.email_acceptance)}/>
                                            </div>
                                            {/* <div className="col-100 col-check-acceptance">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="51" viewBox="0 0 52 51">
                                                    <g id="Group_12293" data-name="Group 12293" transform="translate(-687 -762)">
                                                        <rect id="Rectangle_8368" data-name="Rectangle 8368" width="52" height="51" rx="25.5" transform="translate(687 762)" fill="#f8f5f9"/>
                                                        <g id="Group_11962" data-name="Group 11962" transform="translate(-485.584 -5765.676)">
                                                        <g id="Ellipse_615" data-name="Ellipse 615" transform="translate(1181.647 6536)" fill="#fff" stroke="#e3dcf1" stroke-width="1">
                                                            <ellipse cx="17.176" cy="17.176" rx="17.176" ry="17.176" stroke="none"/>
                                                            <ellipse cx="17.176" cy="17.176" rx="16.676" ry="16.676" fill="none"/>
                                                        </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <input onClick={() => canSendForm()} id="mailchimp_acceptance" type="text" type="checkbox" value="true" />
                                                <label className="acceptance-area" htmlFor="mailchimp_acceptance" dangerouslySetInnerHTML={RenderMarkups(state.testData.finish_step.mailchimp_acceptance)}/>
                                            </div> */}
                                            <div className="col-100 accept-label" dangerouslySetInnerHTML={RenderMarkups(state.testData.finish_step.info_label)}/>
                                        </div>
                                    </div>
                                : ""}
                            </div>
                        </div>
                        <div className="ui-row">
                            <div className="row-card">
                                <div className="prev-btn-wrapper">
                                    {state.lastStep == true ?
                                        <button onClick={() => decrementLastStep()} type='button'><i style={{backgroundImage: `url(${Config('ASSETS_URL')+'/images/arrow-left-long.png'})`}}></i>{state.testData.general_settings.prev_step}</button>
                                    :   
                                        <button onClick={() => decrementStep()} type='button'>{state.testData.general_settings.prev_step}<i style={{backgroundImage: `url(${Config('ASSETS_URL')+'/images/arrow-left-long.png'})`}}></i></button>
                                    }
                                </div>
                                <div className="next-btn-wrapper">
                                    {state.isSpecialAnswer == false && state.lastStep == false && 
                                        <button disabled={!state.canGoFurther && !state.selectedAnswers[state.step]} onClick={() => {state.step == (state.amountOfQuestions - 1) ? setLastStep() : incrementStep()}} type='button'>{state.testData.general_settings.next_step}<i style={{backgroundImage: `url(${Config('ASSETS_URL')+'/images/arrow-right-long.png'})`}}></i></button>
                                    }
                                    {state.isSpecialAnswer == true &&
                                        <button onClick={() => checkIfNextStepsAreAvailable()} type='button'>{state.testData.general_settings.next_step}<i style={{backgroundImage: `url(${Config('ASSETS_URL')+'/images/arrow-right-long.png'})`}}></i></button>
                                    }
                                    {state.lastStep == true &&
                                        <button disabled={!(inputsState.name && inputsState.surname && inputsState.email && inputsState.acceptance)} onClick={() => sendUserData()} type='button'>{state.testData.finish_step.button_label}<i style={{backgroundImage: `url(${Config('ASSETS_URL')+'/images/arrow-right-long.png'})`}}></i></button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}